import { Injectable, ElementRef } from '@angular/core';
export class WrapperService {
public wrapperElementRef: ElementRef;
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function WrapperService_tsickle_Closure_declarations() {
/** @type {?} */
WrapperService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
WrapperService.ctorParameters;
/** @type {?} */
WrapperService.prototype.wrapperElementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
